export default class Sidemenu {
  constructor() {
    this.$menu = $('.banner .side-menu');
    
    this.$burger = $('.banner .burger-menu');
    this.$close = this.$menu.find('.close-icon');

    this.$burger.click(this.open.bind(this))
    this.$close.click(this.close.bind(this))
  }

  open() {
    this.$menu.addClass('side-menu--open');
  }

  close() {
    this.$menu.removeClass('side-menu--open');
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Sidemenu.js